import React from 'react';
import { Container } from 'reactstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import UsersHeader from './components/UsersHeader/index';
import UsersTable from './components/UsersTable/index';
import InviteUsers from './components/InviteUsers/index';

import style from './Users.module.scss';

const Users = ({ totalSize }) => (
  <div>
    <UsersHeader />
    <div className={style.usersInviteContainer}>
      <Container>
        <div className={style.usersInviteRow}>
          {totalSize > 0 && <InviteUsers />}
        </div>
      </Container>
    </div>
    <UsersTable />
  </div>
);

const mapStateToProps = ({ usersReducer }) => ({
  totalSize: usersReducer.totalSize,
});

export default connect(mapStateToProps)(Users);

Users.propTypes = {
  totalSize: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
};
